import RedirectHelper from '../../../../components/RedirectHelper';

const LoginModal = (): JSX.Element => {
  RedirectHelper.redirectToUserManagementWithRedirectSet('/login');
  return <></>;
};

export default LoginModal;
